import React from "react";
import Sidebar from "../components/Sidebar";
import Header from "./components/Header";
import { Outlet } from "react-router";
import SupervisorCurrencyProvider from "../context/SupervisorCurrencyProvider";
import HomeIcon from "@mui/icons-material/Home";
import StoreIcon from "@mui/icons-material/Store";
import PersonIcon from "@mui/icons-material/Person";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";

function LoanManagerDashboard() {
  const navLinks = [
    {
      path: "/loandashboard",
      label: "Dashboard",
      icon: <HomeIcon />,
      exact: true,
    },
    { path: "requests", label: "Requests", icon: <Inventory2RoundedIcon /> },
    { path: "verification", label: "Verification", icon: <StoreIcon /> },
    { path: "disputes", label: "Disputes", icon: <PersonIcon /> },
    { path: "logs", label: "Logs", icon: <AddBusinessIcon /> },
  ];

  return (
    <SupervisorCurrencyProvider>
      <div className="flex h-screen lg:overflow-y-hidden ">
        {/* Sidebar */}
        <Sidebar navLinks={navLinks} />
        {/* Main Content */}
        <main className="flex-grow bg-gray-50 w-10/12 flex flex-col">
          <Header />
          <main className="  w-full ">
            <Outlet />
          </main>
        </main>
      </div>
    </SupervisorCurrencyProvider>
  );
}

export default LoanManagerDashboard;
